import copy from "fast-copy";
import * as is from 'utilities/is';
import { removedItems } from 'utilities/list';
import { omit, serialize } from 'utilities/data';
import { STATE_SERIALIZATION_BLACKLIST } from 'constants';

let logger;

// Exclude these properties when serializing the object's state
export class StateLogger {
    constructor() {
        this.current = {
            version: HAPYAK_VERSION,
            annotations: {},
            project: {},
            variables: ''
        };
    }

    logAnnotationState(id, state) {
        const annotation = this.current.annotations[id];

        if (!annotation) {
            return;
        }

        if (is.defined(state.expanded)) {
            annotation.properties.startExpanded = state.expanded;
        }

        switch (annotation.type) {
            case 'contents':
                annotation.properties.expandedState = state.expanded ? 'expanded' : 'collapsed';
                break;
            case 'contentexplorer':
                annotation.startFocused = state.expanded ? true : false;
                break;
        }
    }

    logVariableState(state) {
        this.current.variables = omit(state, ['NaN', 'result']);
    }

    dump() {
        return this.current;
    }

    toOverrides() {
        return {
            ...this.current,
            annotations: this.stateAsAnnotations
        }
    }

    addAnnotation(props) {
        this.current.annotations[props.id] = { ...this.current.annotations[props.id], ...this.serializeProps(props) };
    }

    removeAnnotation(id) {
        delete this.current.annotations[id];
    }

    setAnnotations(list = []) {
        const currentIds = Object.keys(this.current.annotations),
            updateIds = list.map(l => l.id),
            removedIds = removedItems(currentIds, updateIds);

        if (removedIds.length) {
            removedIds.forEach(r => this.removeAnnotation(r));
        }

        list.forEach(l => this.addAnnotation(l));
    }

    addProject(media = [{}]) {
        this.current.project = {
            videoSource: media[0].url,
            thumbnail: media[0].thumbnail
        };
    }

    serializeProps(props) {
        try {
            return copy(omit(props, STATE_SERIALIZATION_BLACKLIST)); 
        } catch (e) {
            console.warn('Error serializing annotation props. Was one of them an element or something not serializable?', e);
            return {};
        }        
    }

    get stateAsAnnotations() {
        return (
            Object
                .keys(this.current.annotations)
                .map(key => ({
                    id: key,
                    ...this.current.annotations[key]
                }))
        );
    }
}

logger = new StateLogger();

export const getStateLogger = () => logger;